var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16.48 5.614 1.906 1.906.504-.502c.255-.256.395-.595.395-.956s-.142-.7-.398-.955a1.342 1.342 0 0 0-.954-.395h-.002c-.361 0-.7.142-.955.397l-.496.505zM9.99 12.1l1.909 1.908 5.983-5.977-1.915-1.915-5.977 5.984zm-.344.661-.804 2.388 2.395-.797-1.591-1.591zm2.278-8.708c.21 0 .38.172.38.383 0 .21-.17.383-.38.383H4.889a.124.124 0 0 0-.124.123v14.168c0 .068.056.124.124.124h14.168a.124.124 0 0 0 .123-.124v-7.036c0-.21.172-.38.383-.38.21 0 .383.17.383.38v7.545c0 .21-.172.38-.383.38H4.383A.381.381 0 0 1 4 19.617V4.437c0-.21.17-.383.38-.383zm7.471.55c.39.39.605.909.605 1.46a2.05 2.05 0 0 1-.605 1.46l-7.252 7.248a.358.358 0 0 1-.061.048l-.02.011a.407.407 0 0 1-.048.022l-3.331 1.111a.503.503 0 0 1-.113.025V16h-.055a.506.506 0 0 1-.481-.678l1.113-3.341a.397.397 0 0 1 .024-.052l.01-.016a.368.368 0 0 1 .05-.064l7.244-7.244a2.068 2.068 0 0 1 2.92 0z",
    fill: "#F89521",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.97b774dffc93c0b5c6958616ee07b1e8.svg";
export { ForwardRef as ReactComponent };